import {h, Fragment} from "preact"
import { SerpElement } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks";
import { productImagePlaceholder, formatCurrency, currency_symbols } from "../helpers"

export default function ({ product }) {
    const { imageUrl, url, tags1, name, price, listPrice, alternateImageUrls, productId, skus, availability, customFields, categories } = product;
    // console.log(product);
    const [btnValue, setBtnValue] = useState("");

    const [productPrice, setProductPrice] = useState(price);
    const [productListPrice, setProductListPrice] = useState(listPrice);
    const [productUrl, setProductUrl] = useState(url);
    const [opacity, setOpacity] = useState(1);

    const prodHandle = url.split("products/")[1]

    const altImg = alternateImageUrls?.length >= 1 ? alternateImageUrls?.[alternateImageUrls.length - 1] : imageUrl;

    const badge = customFields?.find(k => k.key === "custom-badge")?.value;

    const isArchived = tags1?.some((value) => value.toLowerCase() === "archived");
    const isSoldOut = availability === "OutOfStock";
    const isCustom = tags1?.some((value) => value.toLowerCase() === "custom");
    const isDropdown = tags1?.some((value) => value.toLowerCase() === "dropdown");
    const isPinkFridaySale = tags1?.some((value) => (value === 'pink-friday-sale'));
    // const isPinkFridaySale = categories?.some((value) => (value === 'Pink Friday Sale'));
    // console.log('isPinkFridaySale', isPinkFridaySale);

    const currency = currency_symbols[Shopify.currency.active] ? currency_symbols[Shopify.currency.active] : Shopify.currency.active;

    
    useEffect(() => {
        if (customFields?.find(k => k.key === "custom-pre-order_label")) {
            setBtnValue(customFields?.find(k => k.key === "custom-pre-order_label")?.value)
        } else if (customFields?.find(k => k.key === "custom-ships_by_label")) {
            setBtnValue(customFields?.find(k => k.key === "custom-ships_by_label")?.value)
        } else if (skus?.length > 1 || productId === 6945182843055) {
            setBtnValue("Select Options")
        }

        setProductUrl(Shopify.routes.root + "products/" + prodHandle )

        fetch(Shopify.routes.root + "products/" + prodHandle + ".js")
            .then((response) => response.json())
            .then((data) => {
                let price = data.price ? data.price : data.price_max

                price = (price / 100).toFixed(0);

                setProductPrice(`${price}`);

                if (data.compare_at_price || data.compare_at_price_max && data.compare_at_price_max !== 0) {

                    let comparePrice = data.compare_at_price ? data.compare_at_price : data.compare_at_price_max;

                    comparePrice = (comparePrice / 100).toFixed(0)

                    setProductListPrice(`${comparePrice}`);
                }

            })
            .then(() => {
                const productCards = document.querySelectorAll(".ns-serp .ns-product"); 

                if (productCards) {
                    Array.from(productCards).forEach((card) => {
                        if (card) {
                            card.style.opacity = "1"
                            card.style.visibility = "visible"
                        }
                    })
                }
            });
    }, [product])

    return (
        <SerpElement
            as="div"
            hit={product}
            class="grid__item grid-product small--one-half medium-up--one-quarter"
        >

            <div class="grid-product__content">
                <div class="grid-product__tag grid-product__tag--custom">
                    {badge}
                </div>

                <a href={productUrl} class="grid-product__link">
                    <div class="grid-product__image-mask aos-animate">
                        <div class="image-wrap" style="height: 0; padding-bottom: 100.0%;">
<picture>
<source media="(max-width:764px)" srcset={`${imageUrl}&width=764`} />
<source media="(min-width:765px)" srcset={`${imageUrl}&width=1080`} />
<img src={`${imageUrl}`} class="grid-product__image" alt={name} title={name} width="1080" height="1080" style="height:auto;opacity:1" />
</picture>
  <noscript>
                                <img class="grid-product__image"
                                    src={`${imageUrl}`}
                                    alt={name} />
                            </noscript>
                        </div>
                        <div class="grid-product__secondary-image small--hide">
<picture>
<source media="(max-width:764px)" srcset={``} />
<source media="(min-width:765px)" srcset={`${altImg}&width=1080`} />
<img src={`${altImg}`} class="grid-product__image" alt={name} title={name} width="1080" height="1080" style="height:auto" loading="lazy"/>
</picture>
   </div>
                    </div>
                    <div class="grid-product__meta">
                        <div class="grid-product__title grid-product__title--body">{name}</div>
                        { !isArchived ? ( listPrice != price ? (
                            <>
                                {isPinkFridaySale ? (
                                    <div class="grid-product__price" style="color:#c48c94">
                                        <span class="visually-hidden">Regular price</span>
                                        <span class="grid-product__price--original">{currency}{productPrice}</span>
                                        {/* <span class="grid-product__price--original">{currency}{productListPrice}</span> */}
                                        <span class="visually-hidden">Sale price</span>
                                        {currency}{(productPrice - (productPrice * 0.25)).toFixed(2).split(".")[1] === "00" ? (productPrice - (productPrice * 0.25)).toFixed(0) : (productPrice - (productPrice * 0.25)).toFixed(2)}
                                    </div>
                                ) : (
                                    // <div class="grid-product__price">{`${skus.length > 1 ? `from ${currency}${productPrice}` : `${currency}${productPrice}`}`}</div>
                                    <div class="grid-product__price" style="color:#c48c94">
                                        <span class="visually-hidden">Regular price</span>
                                        <span class="grid-product__price--original">{currency}{productListPrice}</span>
                                        <span class="visually-hidden">Sale price</span>
                                        {currency}{productPrice} 
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                {isPinkFridaySale ? 
                                    <div class="grid-product__price" style="color:#c48c94">
                                        <span class="visually-hidden">Regular price</span>
                                        <span class="grid-product__price--original">{currency}{productPrice}</span>
                                        <span class="visually-hidden">Sale price</span>
                                        {currency}{(productPrice - (productPrice * 0.25)).toFixed(2).split(".")[1] === "00" ? (productPrice - (productPrice * 0.25)).toFixed(0) : (productPrice - (productPrice * 0.25)).toFixed(2)} 
                                    </div>
                                    :
                                    <div class="grid-product__price">{`${skus.length > 1 ? `from ${currency}${productPrice}` : `${currency}${productPrice}`}`}</div>
                                }
                            </>
                        )
                    ) : null }
                    </div>
                </a>
            </div>

            <div class="product-button-container">
                { 
                skus?.length > 1 || productId === 6945182843055 || isCustom || isDropdown ? (
<a href={url}>
<input type="submit" value="Select Options" class="btn" style={{opacity}} onClick={() => setOpacity(0-opacity)} />
<div class="loading-cart-btn">
<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">
<path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/>
</svg>
</div>
</a>
                ) :
                    !isSoldOut ? (
                        btnValue !== "" ? (
<a href={url} id={`AddToCartForm-${productId}`}>
<input type="submit" value={btnValue} class="btn" style={{opacity}} onClick={() => setOpacity(0-opacity)} />
<div class="loading-cart-btn">
<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">
<path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/>
</svg></div>
                            </a>
                        ) : (
                            <form action="/cart/add" data-productid={productId} method="post" id={`AddToCartForm-${productId}`}>
                                <input type="hidden" name="id" value={skus[0].id} />
                                <input type="hidden" name="return_to" value="back" />
                                <input type="submit" value="Add to Bag" id={`addToCart-${productId}`} class="btn" style={{opacity}} onClick={() => setOpacity(0-opacity)} />
                                <div class="loading-cart-btn">
                                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">
                                    <path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/>
                                    </svg>
                                </div>
                            </form>
                        )
                    ) : isSoldOut !== isArchived && name !== "GIFT CARD" ? (
<a href={url}>
<input type="submit" value="Join Waitlist" class="btn" style={{opacity}} onClick={() => setOpacity(0-opacity)} />
<div class="loading-cart-btn">
<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">
<path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/>
</svg>
</div>
</a>
                    ) : isArchived ? (
                        <div class="btn product-archived-collection" style="text-align:center;color:#5e5e5e">Archived ♥</div>
                    ) : null
                }
<form action="/cart" style="text-align:center" class="view-bag product-button-container" id={`view-bag-${productId}`}>
            <input type="submit"  value="View Bag" class="btn product-form__cart-submit" style={{opacity}} onClick={() => setOpacity(0-opacity)} />  
            <div class="loading-cart-btn">
<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">
<path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"/>
</svg>
</div>
          </form>
            </div>
        </SerpElement>
    )
}

// { !isArchived ? ( listPrice != price ? (
//     <div class="grid-product__price" style="color:#c48c94"><span class="visually-hidden">Regular price</span>
//         <span class="grid-product__price--original">{currency}{productListPrice}</span>
//         <span class="visually-hidden">Sale price</span>
//         {currency}{productPrice}
//     </div>
// ) : (
//     <div class="grid-product__price">{`${skus.length > 1 ? `from ${currency}${productPrice}` : `${currency}${productPrice}`}`}</div>
// )
// ) : null }
